import React from 'react';

import './LoadingIndicator.scss';

const defaultProps = {
    message: 'Loading...',
};

interface LoadingIndicatorProps {
    message?: string;
}

export default function LoadingIndicator({ message }: LoadingIndicatorProps & typeof defaultProps) {
    return (
        <span className="loading-indicator">
            <span className="material-icons loading-indicator__icon">refresh</span>
            <span className="loading-indicator__text">{message}</span>
        </span>
    );
}

LoadingIndicator.defaultProps = defaultProps;
